import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { ListingCard, PaginationLinks } from '../../components';
import css from './SearchResultsPanel.module.css';
const SEARCH_PAGE = 'SearchPage';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    pagination,
    search,
    setActiveListing,
    isAuthenticated,
    handleOpenWelcomeAnonymousModal,
    projectListings,
    addToCoachList,
    addToCoachListInProgress,
    addToCoachListError,
    onResetCoachListError,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  // Panel width relative to the viewport
  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  return (
    <div className={classes}>
      <div className={css.listingCards}>
        {listings.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes}
            setActiveListing={setActiveListing}
            isAuthenticated={isAuthenticated}
            handleOpenWelcomeAnonymousModal={handleOpenWelcomeAnonymousModal}
            projectListings={projectListings}
            addToCoachList={addToCoachList}
            addToCoachListInProgress={addToCoachListInProgress}
            addToCoachListError={addToCoachListError}
            from={'SearchPage'}
            onResetCoachListError={onResetCoachListError}
          />
        ))}
        {props.children}
      </div>
      {paginationLinks}
    </div>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  pagination: null,
  rootClassName: null,
  search: null,
  isAuthenticated: false,
  handleOpenWelcomeAnonymousModal: () => null,
  projectListings: [],
  addToCoachList: () => {},
  addToCoachListInProgress: false,
  addToCoachListError: null,
  onResetCoachListError: () => {},
};

const { array, node, object, string, func, bool } = PropTypes;

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
  isAuthenticated: bool,
  handleOpenWelcomeAnonymousModal: func,
  projectListings: array,
  addToCoachList: func,
  addToCoachListInProgress: bool,
  addToCoachListError: propTypes.error,
  onResetCoachListError: func,
};

export default SearchResultsPanel;
